const initialState = null; // null | { status, message }

const apiError = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_API_ERROR':
      return action.payload;
    case 'CLEAR_API_ERROR':
      return null;
    default:
      return state;
  }
};

export default apiError;
